module.exports = __webpack_public_path__ + "img/3.5431c10d.jpg";